import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/api";

export default function AboutSection() {
  return (
    <section id="despre" className="scroll-mt-16 bg-hydro-navy py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
            Despre noi
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl">
            O echipă care face un singur lucru — puțuri de apă.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/65">
            <p>
              Puțul tău este o echipă de foraj din București-Ilfov, specializată pe puțuri
              de apă pentru gospodării: forăm, tubăm cu țeavă PVC albastră cu filet,
              denisipăm puțurile vechi și montăm pompe submersibile și hidrofoare. Nu ne
              împrăștiem în alte meserii — facem un singur lucru și îl facem curat.
            </p>
            <p>
              lucrăm simplu și transparent: prețul orientativ îl vezi dinainte, în
              calculatorul de pe site, cu deplasarea pe localitatea ta inclusă; venim cu
              utilajul nostru în ziua stabilită; și nu plecăm de pe teren până nu verificăm
              împreună apa și debitul. Dacă ceva nu iese cum trebuie, revenim — așa
              înțelegem noi garanția muncii.
            </p>
          </div>
          <a
            href={PHONE_TEL}
            data-testid="about-call-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3.5 text-sm font-bold text-white transition-colors hover:border-hydro-cyan hover:text-hydro-cyan"
          >
            <Phone size={15} />
            Sună la {PHONE_DISPLAY}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
